import styled from '@emotion/styled';
import { Theme } from '@/theme';

const Table = styled.div`
  flex-grow: 1;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.table};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }: { theme: Theme }) => theme.colors.tableBorder};
  border-radius: ${({ theme }: { theme: Theme }) => `${theme.radii.default}px`};
  font-size: ${({ theme }: { theme: Theme }) => `${theme.fontSizes[0]}px`};
  color: ${({ theme }: { theme: Theme }) => theme.colors.text};
  line-height: ${({ theme }: { theme: Theme }) => theme.lineHeights.scale[0]};

  div {
    box-sizing: border-box;
  }
`;

// Todo: Extract base row styles
// theme?
/*
const tableRowBaseStyles = css({
  whiteSpace: 'nowrap',
  borderWidth: 0,
  // borderColor: '#DDD', // props.theme.colors.tableBorder
  borderColor: 'lime',
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  overflow: 'hidden',
})
*/

// type EnhancedColumn = Column<UserInfo> & { style?: ..., headerStyle?: .... }

const TableRow = styled('div')<{ theme: Theme; altRow?: boolean }>((props) => ({
  ':nth-child(odd)': {
    background: props.theme.colors.tableRow,
  },
  ':nth-child(even)': {
    background: props.theme.colors.tableAltRow,
  },
  ...(typeof props.altRow !== 'undefined' && {
    background: !props.altRow
      ? props.theme.colors.tableRow
      : props.theme.colors.tableAltRow,
    ':nth-child(odd)': undefined,
    ':nth-child(even)': undefined,
  }),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '&:last-of-type': {
    borderBottomWidth: 0,
  },
  // new
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '&:hover': {
    background: props.theme.colors.tableHover,
    cursor: 'pointer',
  },
  '&.active': {
    background: props.theme.colors.tableActive,
  },
  minWidth: 'max-content',
}));

const TableCell = styled.div`
  padding: 10px 0 10px 12px;
  margin: 0;
  border: none;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  flex: 0 0 auto;

  :last-of-type {
    padding-right: 12px;
  }
`;

const TableHeaderRow = styled('div')<{ theme: Theme }>((props) => ({
  flexShrink: 0,
  background: props.theme.colors.tableHeader,
  whiteSpace: 'nowrap',
  borderWidth: 0,
  borderColor: props.theme.colors.tableHeader,
  borderTopLeftRadius: props.theme.radii.defaultNested,
  borderTopRightRadius: props.theme.radii.defaultNested,
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  color: props.theme.colors.onTableHeader,
  fontWeight: 'bold',
  textAlign: 'left',
  overflow: 'hidden',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  position: 'relative',
  display: 'flex',
  zIndex: 1,
  minWidth: 'max-content',
}));

const TableHeaderCell = styled.div`
  padding: 12px 0 12px 12px;

  :last-of-type {
    padding-right: 12px;
  }

  margin: 0;
  border: none;
  // display: inline-block;
  // vertical-align: middle;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  cursor: default;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;

  svg {
    flex-shrink: 0;
  }
`;

// mock data for stories
export const fooData = ['foo', 'bar', 'baz', 'doo', 'doe', 'dum'];

export { Table, TableRow, TableCell, TableHeaderRow, TableHeaderCell };
